/**
 * Panneau de logs tactile (VConsole). Ne modifie pas l’auth ni le reste de l’app.
 *
 * - **yarn dev** : activé automatiquement.
 * - **site déployé** : ajoute `?vconsole=1` à l’URL une fois, ou en console / bookmark :
 *   `localStorage.setItem('batiweb_vconsole','1')` puis recharge.
 */
export function initDevMobileConsole(): void {
  if (typeof window === 'undefined') return

  const params = new URLSearchParams(window.location.search)
  if (params.get('vconsole') === '1') {
    try {
      window.localStorage.setItem('batiweb_vconsole', '1')
    } catch {
      /* private mode */
    }
    const url = new URL(window.location.href)
    url.searchParams.delete('vconsole')
    window.history.replaceState({}, '', url.pathname + url.search + url.hash)
  }

  const enabledByStorage = (() => {
    try {
      return window.localStorage.getItem('batiweb_vconsole') === '1'
    } catch {
      return false
    }
  })()

  if (!import.meta.env.DEV && !enabledByStorage) return

  void import('vconsole')
    .then(({ default: VConsole }) => {
      new VConsole({
        theme: 'dark',
        maxLogNumber: 300,
      })
      // Au-dessus des modales MUI / drawers
      const z = document.createElement('style')
      z.textContent = '#__vconsole,.vc-switch { z-index: 2147483646 !important; }'
      document.head.appendChild(z)

      console.info(
        '[batiweb] VConsole prêt. Filtre « batiweb » dans la barre du bas. Inscription : chercher [batiweb:signup]'
      )
    })
    .catch((err) => {
      // Visible dans Safari → Ordinateur en USB si VConsole ne charge pas
      console.error('[batiweb] VConsole impossible à charger', err)
    })
}
